import FooterWrapper from './FooterWrapper.component';

export default FooterWrapper;